/**
 * F11 — Interior Execution Yup schemas (v2).
 * Field renames vs v1: prerequisiteStatusTypeId → prerequisiteWbsStageId (PART 1 §7).
 * Mirrors RequestExecutionStageDefinition (POST/PUT /api/interior/execution-plan).
 */
import * as yup from "yup";

/**
 * POST/PUT /interior/execution-plan — create or update a stage definition.
 * `prerequisiteWbsStageId` is the v2 FK to the wbs_stage catalog (was prerequisiteStatusTypeId).
 */
export const executionStageSchema = yup.object({
  stageKey: yup
    .string()
    .trim()
    .required("Stage key is required"),
  stageLabel: yup
    .string()
    .trim()
    .required("Stage label is required"),
  sequenceOrder: yup
    .number()
    .typeError("Sequence order must be a number")
    .integer("Must be a whole number")
    .min(1, "Must be at least 1")
    .required("Sequence order is required"),
  // v2: prerequisiteWbsStageId replaces prerequisiteStatusTypeId (PART 1 §7)
  prerequisiteWbsStageId: yup
    .number()
    .typeError("Prerequisite stage must be selected")
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  estimatedDurationDays: yup
    .number()
    .typeError("Duration must be a number")
    .integer("Must be a whole number")
    .min(1, "Must be at least 1 day")
    .required("Estimated duration is required"),
  bufferDays: yup
    .number()
    .typeError("Buffer must be a number")
    .integer("Must be a whole number")
    .min(0, "Cannot be negative")
    .default(0),
  isActive: yup.boolean().default(true),
});
